import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../authConfig";

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
export const msalInstance = new PublicClientApplication(msalConfig);

// Legacy export names for backward compatibility (if needed elsewhere in the codebase)
export const authProvider = msalInstance;
export const authProviderJWT = msalInstance;
